export const navTestId = {
    companyLogo: 'companyLogo',
    userDropDownUserLabel: 'userDropDownUserLabel',
    disguiseOptionsUser: 'disguiseOptionsUser',
    disguiseOptionsAdmin: 'disguiseOptionsAdmin',
    userDropDownLanguageSelector: 'userDropDownLanguageSelector',
    userDropDownAdminReturn: 'userDropDownAdminReturn',
    userDropDownClearCache: 'userDropDownClearCache',
    userDropDownEditSuperAdmins: 'userDropDownEditSuperAdmins',
    userDropDownRefreshData: 'userDropDownRefreshData',
    userDropDownGoToDesktop: 'userDropDownGoToDesktop',
    userDropDownHelpMenu: 'userDropDownHelpMenu',
    userDropDownLogout: 'userDropDownLogout',
    userDropDownDesktop: 'userDropDownDesktop',
    userDropDownMobile: 'userDropDownMobile',
    dashboard: 'nav-dashboard',
    looker: 'nav-looker',
    manufacturers: 'nav-manufacturers',
    retailers: 'nav-retailers',
    stores: 'nav-stores',
    dataWarehouse: 'nav-dataWarehouse',
    reps: 'nav-reps',
    users: 'nav-users',
    locations: 'nav-locations',
    work: 'nav-work',
    mPlans: 'nav-mPlans',
    hotTasks: 'nav-hotTasks',
    tools: 'nav-tools',
    reportingCenter: 'nav-reportingCenter',
    legacyReportingCenter: 'nav-legacyReportingCenter',
    itemManager: 'nav-itemManager',
    scheduling: 'nav-scheduling',
    planning: 'nav-planning',
    aiScheduling: 'nav-aiScheduling',
    aiSchedulingPreferences: 'nav-aiSchedulingPreferences',
    executionDashboard: 'nav-executionDashboard',
    communications: 'nav-communications',
    companySettings: 'nav-companySettings',
    usergroups: 'nav-usergroups',
    roles: 'nav-roles',
    skillsAndCapabilities: 'nav-skillsAndCapabilities',
    mPlanTemplateTypes: 'nav-mPlanTemplateTypes',
    billingCodes: 'nav-billingCodes',
    mPlanTags: 'nav-mPlanTags',
    repTypes: 'nav-repTypes',
    reasons: 'nav-reasons',
};

export default {
    navTestId,
};
